import propTypes from "prop-types";
import { APP, BEACON, PLACEMENT } from "@asosteam/asos-web-adverts-sdk";
import useGetAdverts from "./useGetAdverts";
import Image from "./components/image";
import AdvertLink from "./components/advertLink";
import triggerBeacon from "./triggerBeacon";
import styles from "./index.module.css";

const Advert = ({
  sdkInstance,
  app,
  placement,
  requestDisplayAdverts,
  requestSponsoredProducts,
  breakCache,
  parameters,
  handleErrors,
  rootMargin,
  onLinkClickHandler
}) => {
  const { LineItemID, format, rendering, responseId } = useGetAdverts({
    sdkInstance,
    app,
    placement,
    requestDisplayAdverts,
    requestSponsoredProducts,
    breakCache,
    parameters,
    handleErrors
  });

  const isMpuAdvert = format === "custom_asos-mpu";

  return rendering ? (
    <AdvertLink
      url={rendering?.redirect_url}
      lineItemId={LineItemID}
      onClick={(event) => {
        onLinkClickHandler && onLinkClickHandler(event);

        triggerBeacon(
          sdkInstance,
          app,
          placement,
          BEACON.ON_CLICK,
          handleErrors
        );
      }}
      className={isMpuAdvert ? styles.advertMpu : styles.advertBanner}
    >
      <Image
        key={responseId}
        mpu={isMpuAdvert}
        rendering={rendering}
        rootMargin={rootMargin}
        onImageInView={() =>
          triggerBeacon(
            sdkInstance,
            app,
            placement,
            BEACON.ON_VIEW,
            handleErrors
          )
        }
      />
    </AdvertLink>
  ) : null;
};

Advert.propTypes = {
  sdkInstance: propTypes.object,
  app: propTypes.oneOf(Object.values(APP)),
  placement: propTypes.oneOf(Object.values(PLACEMENT)),
  requestDisplayAdverts: propTypes.bool,
  requestSponsoredProducts: propTypes.bool,
  breakCache: propTypes.bool,
  parameters: propTypes.object,
  handleErrors: propTypes.func,
  rootMargin: propTypes.string,
  onLinkClickHandler: propTypes.func
};

export default Advert;
